import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Sign-in failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mx-auto max-w-md px-6 py-24">
      <div className="mono text-xs text-primary mb-2">// authenticate</div>
      <h1 className="text-4xl font-black tracking-tighter mb-8">Sign in.</h1>
      <form onSubmit={submit} className="space-y-5 border border-border p-8">
        <div>
          <Label htmlFor="email" className="text-xs uppercase tracking-widest text-muted-foreground">Email</Label>
          <Input id="email" data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 rounded-none bg-input" />
        </div>
        <div>
          <Label htmlFor="password" className="text-xs uppercase tracking-widest text-muted-foreground">Password</Label>
          <Input id="password" data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 rounded-none bg-input" />
        </div>
        <Button type="submit" disabled={busy} data-testid="login-submit" className="w-full rounded-none bg-primary text-primary-foreground hover:bg-primary/90">
          {busy ? "Signing in…" : "Sign in"}
        </Button>
      </form>
      <p className="mt-6 text-sm text-muted-foreground">No account? <Link to="/register" className="text-primary hover:underline">Join the chamber →</Link></p>
    </div>
  );
}
